var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { defineComponent, useAttrs, provide, createBlock, openBlock, withCtx, createVNode, createCommentVNode, unref, normalizeProps, guardReactiveProps, renderSlot } from "vue";
import { useBetterVModel } from "../../../../composables/useBetterVModel.js";
import { useRealProps } from "../../../../composables/useRealProps.js";
import { useSlotsExists } from "../../../../composables/useSlotsExists.js";
import { SmartRenderer, resolveVNode } from "../../../../lib/utils.js";
import _sfc_main$4 from "../core/TooltipContent.js";
import _sfc_main$1 from "../core/TooltipProvider.js";
import _sfc_main$3 from "../core/TooltipTrigger.js";
import { TOOLTIP_OPEN_MODEL_VALUE_KEY } from "../injectionKeys.js";
import _sfc_main$2 from "./TooltipBind.js";
import { S as Slot } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Primitive/Slot.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipWrapper",
  props: {
    content: {
      type: [Object, String, Number, Boolean, null, Array, Function]
    },
    placement: {},
    reference: {},
    open: {
      type: Boolean
    },
    defaultOpen: {
      type: Boolean
    },
    usedInDirectives: {
      type: Boolean
    }
  },
  emits: ["update:open"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props, emits = __emit, attrs = useAttrs(), realProps = useRealProps(), openModelValue = useBetterVModel({
      props,
      realProps,
      key: "open",
      defaultValue: props.defaultOpen
    }), slotsExists = useSlotsExists(["default", "content"]);
    provide(TOOLTIP_OPEN_MODEL_VALUE_KEY, openModelValue);
    function handleTooltipOpenUpdate(value) {
      emits("update:open", value);
    }
    return __name(handleTooltipOpenUpdate, "handleTooltipOpenUpdate"), (_ctx, _cache) => (openBlock(), createBlock(_sfc_main$1, null, {
      default: withCtx(() => [createVNode(_sfc_main$2, {
        "used-in-directives": props.usedInDirectives,
        open: props.open,
        "default-open": props.defaultOpen,
        "handle-tooltip-open-update": handleTooltipOpenUpdate
      }, {
        default: withCtx(() => [createVNode(_sfc_main$3, {
          "as-child": "",
          reference: props.reference
        }, {
          default: withCtx(() => [createVNode(unref(Slot), normalizeProps(guardReactiveProps(unref(attrs))), {
            default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
            _: 3
          }, 16)]),
          _: 3
        }, 8, ["reference"]), unref(slotsExists).content || props.content ? (openBlock(), createBlock(_sfc_main$4, {
          key: 0,
          side: props.placement
        }, {
          default: withCtx(() => [renderSlot(_ctx.$slots, "content", {}, () => [createVNode(unref(SmartRenderer), {
            children: unref(resolveVNode)(props.content)
          }, null, 8, ["children"])])]),
          _: 3
        }, 8, ["side"])) : createCommentVNode("", !0)]),
        _: 3
      }, 8, ["used-in-directives", "open", "default-open"])]),
      _: 3
    }));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipWrapper.js.map
